import { type RefObject, useCallback, useEffect, useRef, useState } from 'react';

import { useIntersection } from '@cx-modules/hooks';
import {
  detectBrowser,
  getHeaderHeight,
  getSubeventHeaderHeight,
  getSubeventHeaderTabsHeight,
} from '@cx-modules/utils';

export const useSmallBookieLogos = (
  adjuster = 0,
): {
  intersectionRef: RefObject<HTMLDivElement> | null;
  shouldShrink: boolean;
  top: number;
} => {
  const [shouldShrink, setShouldShrink] = useState(false);
  const [top, setTop] = useState(0);
  const topRef = useRef(0);
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    topRef.current = getHeaderHeight() + getSubeventHeaderHeight() + getSubeventHeaderTabsHeight() + 85;
  }, []);

  useEffect(() => {
    if (detectBrowser() === 'safari') {
      setIsSafari(true);
    }
  }, []);

  const handleIntersection = useCallback((isIntersecting: boolean): void => {
    const newTop = getHeaderHeight() + getSubeventHeaderHeight() + getSubeventHeaderTabsHeight() + 85;
    setTop(newTop);
    if (newTop !== topRef.current) {
      topRef.current = newTop;
    } else {
      setShouldShrink(!isIntersecting);
    }
  }, []);

  const setRootMargin = useCallback(() => {
    return `${top > 0 ? `-${top + adjuster}` : 0}px 0px 0px 0px`;
  }, [top, adjuster]);

  const intersectionRef = useIntersection<HTMLDivElement>({
    handleIntersection,
    setRootMargin,
  });

  return {
    intersectionRef: intersectionRef as RefObject<HTMLDivElement> | null,
    shouldShrink: isSafari ? false : shouldShrink,
    top: isSafari ? top - 130 : top - 125,
  };
};
